import React, { useEffect, useState } from 'react';

import { ThreeDShowroomContent } from './3DShowroomContent';

export const ThreeDShowroom: React.FC = () => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    setShouldRender(true);
  }, []);

  return shouldRender ? <ThreeDShowroomContent /> : <div id="three-d-showroom-placeholder" />;
};
